<template>
  <div class="customization-calandar-wrapper">
    <div class="customization-title">Choose Date</div>
    <VueDatePicker
      id="sib-date-picker"
      v-model="date"
      required
      :enable-time-picker="false"
      :format="format"
      auto-apply
      placeholder="Choose Date"
      month-name-format="long"
      position="left"
    ></VueDatePicker>
  </div>
</template>

<script lang="ts" setup>
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import { onMounted, ref, watch } from 'vue'
import {
  CUSTOMILY_OPTION_SORT_ID_WRAPPER_SELECTOR_V2,
  INPUT_TEXT_CUSTOMILY_SELECTOR,
} from '@/utils'
import { useProductCustomization } from './composables/ProductCustomization'

const props = withDefaults(
  defineProps<{
    dayIds: string[] | number[]
    monthId: string | number
    yearId: string | number
  }>(),
  {}
)

const { changeInputCustomily, changeOptionSelectCustomily } =
  useProductCustomization()

const date = ref('')

const format = (date: any) => {
  const day = date.getDate()
  const month = date.getMonth() + 1
  const year = date.getFullYear()

  return `${year}-${month < 10 ? '0' + month : month}-${
    day < 10 ? '0' + day : day
  }`
}

onMounted(() => {
  watch(
    () => date.value,
    (value) => {
      if (value) selectedCalendarHandler()
    }
  )
})

function selectedCalendarHandler() {
  //update year
  const yearElement = getElementCustomilyBySortId(props.yearId)
  if (yearElement) {
    const year = getFullYear(date.value)
    changeInputCustomily(year, yearElement)
  }

  //update month
  const monthElement = getElementCustomilyBySortId(props.monthId)
  if (monthElement) {
    const month = getMonthName(date.value)
    changeInputCustomily(month, monthElement)
  }

  // update days
  generateDayTable(date.value)
}

function generateDayTable(dateString: string) {
  const date = new Date(dateString)
  const dateSelected = date.getDate()
  const month = date.getMonth()
  const year = date.getFullYear()
  const firstDayOfWeekInMonth = getFirstDayOfWeekInMonth(month, year)
  const daysInMonth = getDaysInMonth(month, year)
  const finalsDays = getFinalsDays(daysInMonth, firstDayOfWeekInMonth)

  let index = 0
  for (let i = +props.dayIds[0]; i < +props.dayIds[1]; i = i + 2) {
    if (index < finalsDays.length) {
      const textElement = getElementCustomilyBySortId(i, 'input')
      const heartElement = getElementCustomilyBySortId(i + 1, 'select')
      if (heartElement) {
        if (finalsDays[index] == dateSelected) {
          changeOptionSelectCustomily('YES', heartElement)
        } else {
          changeOptionSelectCustomily('NO', heartElement)
        }
      }
      if (textElement) {
        if (finalsDays[index]) {
          changeInputCustomily(finalsDays[index].toString(), textElement)
        } else {
          changeInputCustomily('', textElement)
        }
      }
    }
    index++
  }
}

function getElementCustomilyBySortId(sortId: string | number, type = 'input') {
  if (type == 'input') {
    return document.querySelector(
      `.${CUSTOMILY_OPTION_SORT_ID_WRAPPER_SELECTOR_V2.replace(
        'option_sort_id',
        sortId.toString()
      )} input[type="text"]`
    )
  } else {
    return document.querySelector(
      `.${CUSTOMILY_OPTION_SORT_ID_WRAPPER_SELECTOR_V2.replace(
        'option_sort_id',
        sortId.toString()
      )} select`
    )
  }
}

function getDaysInMonth(month: number, year: number): number[] {
  let date = new Date(year, month, 1)
  let days: number[] = []

  while (date.getMonth() === month) {
    days.push(date.getDate())
    date.setDate(date.getDate() + 1)
  }
  return days
}

function getFirstDayOfWeekInMonth(month: number, year: number): number {
  const date = new Date(year, month, 1)
  return date.getDay()
}

function getFinalsDays(daysInMonth: number[], firstDayOfWeekInMonth: number) {
  let finals: (number | string)[] = []

  for (let i = 1; i <= 42; i++) {
    if (daysInMonth.includes(i - firstDayOfWeekInMonth)) {
      finals.push(i - firstDayOfWeekInMonth)
    } else {
      finals.push('')
    }
  }
  return finals
}

function getFullYear(dateString: string) {
  const date = new Date(dateString)
  return date.getFullYear() + ''
}

function getMonthName(dateString: string) {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]
  const date = new Date(dateString)
  return months[date.getMonth()]
}
</script>

<style lang="scss">
.customization-calandar-wrapper {
  #sib-date-picker {
    svg {
      width: 1.25rem;
      height: 1.25rem;
      top: 51%;
    }
    input {
      padding-left: 35px !important;
    }
    .dp__month_year_row,
    .dp__calendar_header,
    .dp__arrow_top {
      background-color: #f5f5f5;
    }
    .dp__menu_inner {
      padding: 0;
    }
    .dp__month_year_row {
      padding: 0.5rem 0.5rem 0 0.5rem;
    }
    .dp__calendar_header,
    .dp__calendar[role='rowgroup'] {
      padding: 0 0.5rem;
    }
    .dp__cell_inner {
      border-radius: 50%;
      margin: 0 2px;
    }
  }
}
</style>
